import { render } from "./ProProdutosAvulsosView.vue?vue&type=template&id=0666ffd4&scoped=true"
import script from "./ProProdutosAvulsosView.vue?vue&type=script&lang=js"
export * from "./ProProdutosAvulsosView.vue?vue&type=script&lang=js"

import "./ProProdutosAvulsosView.vue?vue&type=style&index=0&id=0666ffd4&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD24\\Desenvolvimento\\Corofergs\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0666ffd4"]])

export default __exports__